export default __webpack_public_path__ + "static/media/warning_tick.895ac599.svg";